
import { parentMixin } from 'vux/src/mixins/multi-items'

export default {
name: 'Tab',
mixins: [parentMixin],
mounted () {

this.$nextTick(() => {
setTimeout(() => {
this.hasReady = true
}, 0)
})
},
props: {
lineWidth: {
type: Number,
default: 3
},
activeColor: String,
barActiveColor: String,
defaultColor: String,
disabledColor: String,
animate: {
type: Boolean,
default: true
},
customBarWidth: [Function, String],
preventDefault: Boolean,
scrollThreshold: {
type: Number,
default: 4
},
barPosition: {
type: String,
default: 'bottom',
validator (val) {
return ['bottom', 'top'].indexOf(val) !== -1
}
}
},
computed: {
barLeft () {
if (this.hasReady) {
const nav = this.$refs.nav
const count = this.scrollable ? (nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width) : this.number
return `${this.currentIndex * (100 / count)}%`
}
},
barRight () {
if (this.hasReady) {
const nav = this.$refs.nav
const count = this.scrollable ? (nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width) : this.number
return `${(count - this.currentIndex - 1) * (100 / count)}%`
}
},

innerBarStyle () {
return {
width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
background: this.barActiveColor || this.activeColor
}
},

barStyle () {
const commonStyle = {
left: this.barLeft,
right: this.barRight,
display: 'block',
height: this.lineWidth + 'px',
transition: !this.hasReady ? 'none' : null
}
if (!this.customBarWidth) {
commonStyle.background = this.barActiveColor || this.activeColor
} else {
commonStyle.background = 'transparent'
}
return commonStyle
},
barClass () {
return {
'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
}
},
scrollable () {
return this.number > this.scrollThreshold
}
},
watch: {
currentIndex (newIndex, oldIndex) {
this.direction = newIndex > oldIndex ? 'forward' : 'backward'
this.$emit('on-index-change', newIndex, oldIndex)
this.hasReady && this.scrollToActiveTab()
}
},
data () {
return {
direction: 'forward',
right: '100%',
hasReady: false
}
},
methods: {
scrollToActiveTab () {
if (!this.scrollable || !this.$children || !this.$children.length) {
return
}
const currentIndexTab = this.$children[this.currentIndex].$el
let count = 0

const step = () => {
const scrollDuration = 15
const nav = this.$refs.nav
nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration
if (++count < scrollDuration) {
window.requestAnimationFrame(step)
}
}
window.requestAnimationFrame(step)
}
}
}



// WEBPACK FOOTER //
// ./src/components/Tab/Tab.vue